import { useInfiniteQuery } from "react-query"
import supabase from "../supabase"

const listClinics = async ({ coordinates }) => {
  const { data, error } = await supabase
    .rpc("clinics_with_distance", {
      lat: coordinates.lat,
      lng: coordinates.lng,
    })
    .order("distance")
  // .range(cursor, cursor + pageSize)

  if (error) {
    throw new Error(error.message)
  }

  return data
}

const useClinicSearch = (params, options) =>
  useInfiniteQuery(["clinicSearch", params], () => listClinics(params), options)

export default useClinicSearch
